module.exports = __webpack_public_path__ + "img/angular.22925b94.png";